const DOMPurify = require('dompurify');

exports.sanitize = (html) => {
  return { __html: DOMPurify.sanitize(html) };
};
